import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AcknowledgmentScreenComponent } from './form/acknowledgment-screen/acknowledgment-screen.component';
import { EmailVerificationScreenComponent } from './form/contact-self-service-forms/email-verification-screen/email-verification-screen.component';
import { LandingScreenComponent } from './form/contact-self-service-forms/landing-screen/landing-screen.component';
import { FormComponent } from './form/form.component';
import { PageNotFoundComponent } from './form/page-not-found/page-not-found.component';
import { RegUpdateScreenComponent } from './form/contact-self-service-forms/reg-update-screen/reg-update-screen.component';
import { SelfServiceAcknowlagementScreenComponent } from './form/contact-self-service-forms/self-service-acknowlagement-screen/self-service-acknowlagement-screen.component';
import { SelfServiceExpiryScreenComponent } from './form/contact-self-service-forms/self-service-expiry-screen/self-service-expiry-screen.component';
const routes: Routes = [
  { path: 'form/:formTip', component: FormComponent },
  {
    path: 'contact-form',
    children: [
      { path: 'landing/:type', component: LandingScreenComponent },
      {
        path: 'email-verification/:type',
        component: EmailVerificationScreenComponent,
      },
      {
        path: 'registration',
        component: RegUpdateScreenComponent,
      },
      {
        path: 'update',
        component: RegUpdateScreenComponent,
      },
      {
        path: 'self-service-acknowledgment-screen',
        component: SelfServiceAcknowlagementScreenComponent,
      },
      {
        path: 'self-service-expired',
        component: SelfServiceExpiryScreenComponent,
      },
    ],
  },
  { path: 'acknowledgment-screen', component: AcknowledgmentScreenComponent },
  { path: 'page-not-found', component: PageNotFoundComponent },
  { path: '**', redirectTo: 'page-not-found', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
